"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyRewardsTasksEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const LocationDto_1 = require("../locations/LocationDto");
const LocationEntity_1 = require("../locations/LocationEntity");
const LoyaltyRewardsTasksDto_1 = require("./LoyaltyRewardsTasksDto");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const INDEX_NOT_FOUND = -1;
class LoyaltyRewardsTasksEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, loyaltyRewardsTask) {
        super();
        this._requiredFieldsSetStatus = {
            locationId: false,
            kind: false,
            title: false,
            description: false,
            points: false,
            qrCodeValue: false,
            expiresAt: false
        };
        this._dependencies = dependencies;
        if (loyaltyRewardsTask === undefined) {
            this._dto = new LoyaltyRewardsTasksDto_1.LoyaltyRewardsTasksDto();
        }
        else if (loyaltyRewardsTask instanceof LoyaltyRewardsTasksDto_1.LoyaltyRewardsTasksDto) {
            this._dto = new LoyaltyRewardsTasksDto_1.LoyaltyRewardsTasksDto(loyaltyRewardsTask);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (loyaltyRewardsTask instanceof LoyaltyRewardsTasksEntity) {
            this._dto = new LoyaltyRewardsTasksDto_1.LoyaltyRewardsTasksDto(loyaltyRewardsTask._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new LoyaltyRewardsTasksDto_1.LoyaltyRewardsTasksDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getLocation() {
        if (this._dto.locationId === undefined) {
            return undefined;
        }
        if (this._dto.location === undefined) {
            throw new Error("Cannot call getLocation without first loading the Location.");
        }
        if (!this._locationEntity && this._dto.location) {
            this._locationEntity = new LocationEntity_1.LocationEntity(this._dependencies, this._dto.location);
        }
        return this._locationEntity;
    }
    setLocation(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LocationDto_1.LocationDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLocationId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            this._locationEntity = untrustedValue;
        }
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        this._setIsDirty(true);
    }
    getKind() {
        return this._dto.kind;
    }
    setKind(untrustedValue) {
        const maxLength = 10;
        if (typeof untrustedValue !== "string") {
            throw new Error("setKind(): Invalid type");
        }
        const _untrustedValue = untrustedValue.trim();
        this.clearError("kind");
        this._requiredFieldsSetStatus.kind = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("kind", "Kind is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("kind", `Kind has exceeded the maximum length (${maxLength} chr).`));
        }
        else if (_untrustedValue !== "reward" && _untrustedValue !== "task") {
            this.addError(new ValidationError_1.ValidationError("kind", 'Kind must be "reward" or "task".'));
        }
        if (!this.isNew && _untrustedValue === this._dto.kind) {
            return;
        }
        else {
            this._dto.kind = _untrustedValue;
            this._setIsDirty(true);
        }
    }
    getTitle() {
        return this._dto.title;
    }
    setTitle(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("title");
        this._requiredFieldsSetStatus.title = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("title", "Title is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("title", `Title has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.title) {
            return;
        }
        this._dto.title = _untrustedValue;
        this._setIsDirty(true);
    }
    getDescription() {
        return this._dto.description;
    }
    setDescription(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("description");
        this._requiredFieldsSetStatus.description = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("description", "Description is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("description", `Description has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.description) {
            return;
        }
        this._dto.description = _untrustedValue;
        this._setIsDirty(true);
    }
    getImageUrl() {
        return this._dto.imageUrl;
    }
    setImageUrl(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("imageUrl");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("imageUrl", `Image Url has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.imageUrl) {
            return;
        }
        this._dto.imageUrl = _untrustedValue;
        this._setIsDirty(true);
    }
    getPoints() {
        return this._dto.points;
    }
    setPoints(untrustedValue) {
        let _untrustedValue;
        this.clearError("points");
        this._requiredFieldsSetStatus.points = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("points", "Points is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("points", "Points is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.points) {
            return;
        }
        this._dto.points = _untrustedValue;
        this._setIsDirty(true);
    }
    getQrCodeValue() {
        return this._dto.qrCodeValue;
    }
    setQrCodeValue(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("qrCodeValue");
        this._requiredFieldsSetStatus.qrCodeValue = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("qrCodeValue", "QR Code Value is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("qrCodeValue", `QR Code Value has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.qrCodeValue) {
            return;
        }
        this._dto.qrCodeValue = _untrustedValue;
        this._setIsDirty(true);
    }
    getCanOnlyRedeemOnce() {
        return this._dto.canOnlyRedeemOnce;
    }
    setCanOnlyRedeemOnce(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("canOnlyRedeemOnce", "Can Only Redeem Once is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("canOnlyRedeemOnce", "Can Only Redeem Once is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        if (!this.isNew && _untrustedValue === this._dto.canOnlyRedeemOnce) {
            return;
        }
        this.clearError("canOnlyRedeemOnce");
        this._dto.canOnlyRedeemOnce = _untrustedValue;
        this._setIsDirty(true);
    }
    getExpiresAt() {
        return this._dto.expiresAt;
    }
    setExpiresAt(untrustedValue) {
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("expiresAt");
        this._requiredFieldsSetStatus.expiresAt = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("expiresAt", "Expires At is required."));
        }
        else if (!isFutureDate(_untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("expiresAt", "Expires At must be a future date."));
        }
        if (!this.isNew && _untrustedValue === this._dto.expiresAt) {
            return;
        }
        this._dto.expiresAt = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadLocationAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLocationId()) {
                    return;
                }
                this._emit("before-loadLocationAsync");
                this._dto.location = yield this._dependencies.locationDatastore
                    .getAsync(this.getLocationId(), expand);
                delete this._locationEntity;
                this._emit("after-loadLocationAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.loyaltyRewardsTasksDatastore
                    .getAsync(id, expand);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Loyalty Rewards and Tasks is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.loyaltyRewardsTasksDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.loyaltyRewardsTasksDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Loyalty Rewards and Tasks cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.loyaltyRewardsTasksDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.LoyaltyRewardsTasksEntity = LoyaltyRewardsTasksEntity;
function isFutureDate(dateToTest) {
    const date = new Date(dateToTest);
    const now = new Date();
    return date > now;
}
//# sourceMappingURL=LoyaltyRewardsTasksEntity.js.map